export const menuData = [
  {
    title: "Home",
    items: [
      { label: "Vision & Mission", link: "/vision-mission" },
      { label: "Company Profile", link: "/company-profile" },
      { label: "Board Of Directors", link: "/board-of-directors" },
      // { label: "Key Management", link: "#action/3.4" },
      { label: "Message of CEO", link: "/message-of-ceo" },
      { label: "Regulatory Info", link: "/regulatory-info" },
      {
        label: "Legals-Associate-Company",
        link: "/legals-associated-companies",
      },
      { label: "Contact Us", link: "/contact-us" },
    ],
  },
  {
    title: "Investor Awareness",
    items: [
      { label: "Risk Disclosure", link: "/risk-disclosure" },
      { label: "SECP Investor Guide", link: "/secp-investor-guide" },
      { label: "PSX Rule Book", link: "/psx-rule-book" },
      { label: "PSX Investor Guide", link: "/psx-investor-guide" },
      {
        label: "Dispute Resolution/Arbitration",
        link: "/dispute-resolution-arbitration",
      },
      {
        label: "Common Terms of Share Market",
        link: "/common-terms-of-share-market",
      },
      {
        label: "Terms & Conditions of Online Trading",
        link: "/terms-conditions-of-online-trading",
      },
      { label: "Financial Information", link: "/financial-information" },
    ],
  },
  {
    title: "Resources & Tools",
    items: [
      { label: "Commission Structure", link: "/commision-structure" },
      { label: "About Online Trading", link: "/about-online-trading" },
      {
        label: "About VTRADE & its Features",
        link: "/about-vtrade-its-feature",
      },
      // { label: "How to Open Account", link: "#action/3.1" },
      { label: "Download Trading Apps", link: "/download-trading-apps" },

      {
        label: "Download Account Opening Form",
        link: "/download-account-opening-form",
      },
      { label: "FAQ's", link: "/faq" },
    ],
  },
  {
    title: "Orbit Insights",
    items: [
      { label: "Policies & Procedures", link: "/policies-procedures" },
      { label: "Product & Services", link: "/product-and-services" },
      // { label: "Research", link: "#action/3.1" },
      { label: "Fund Your Account", link: "/fund-your-account" },
      { label: "Bank Details", link: "/bank-details" },
      // { label: "Career", link: "#action/3.1" },
      // { label: "Event Gallery", link: "#action/3.1" },
    ],
  },
  {
    title: "Miscellaneous",
    items: [
      {
        label: "Investor Complaints & Queries",
        link: "/investor-complaints-queries",
      },
      // { label: "Documents Required for Account Open", link: "#action/3.1" },
      { label: "Important Links", link: "/important-links" },
      { label: "Software Download", link: "/software-download" },
      { label: "Account Open Details", link: "/account-open-detail" },
    ],
  },
  {
    title: "Advance Trading",
    items: [
      { label: "Trading Dashboard", link: "/trading-dashboard/PSX" },
      { label: "Technical Analysis", link: "/technical-analysis" },
      { label: "Real Time Trading Chart", link: "/chart-view" },
    ],
  },
];

export const demoAccountMenu = [
  {
    title: "Home",
    navigate: "/demo-home",
  },
  {
    title: "Account",
    navigate: "/demo-account",
  },
  {
    title: "Watchlist",
    navigate: "/demo-watchlist",
  },
  {
    title: "Logs",
    navigate: "/logs",
  },
];
